module.exports = __webpack_public_path__ + "img/skillsB-5.58a65b14.png";